/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

//window.Vue = require('vue');
import Vue from 'vue'
import moment from 'moment-timezone';
moment.tz.setDefault('America/Los_Angeles');
import store from './store';
import axios from 'axios';
import VueCookies from 'vue-cookies';
import mixin from './mixin.js';
Vue.use(mixin);

// Import Bootstrap CSS
import 'bootstrap/dist/css/bootstrap.min.css';

// Import Bootstrap JavaScript (optional if you're using Bootstrap's JS features)
import 'bootstrap';


import VGoogleTranslate from 'v-google-translate';
Vue.use(VGoogleTranslate);

import VueScrollTo from 'vue-scrollto';
Vue.use(VueScrollTo);
Vue.use(VueCookies);

import VTooltip from 'v-tooltip';
Vue.use(VTooltip);

import VueEasyLightbox from 'vue-easy-lightbox';
Vue.use(VueEasyLightbox);

import VueCompositionApi from '@vue/composition-api';
Vue.use(VueCompositionApi);

//import 'vue-suggestion/dist/vue-suggestion.css';
import VueSuggestion from 'vue-suggestion';
Vue.use(VueSuggestion);

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

// define the plugin and pass object for config
Vue.use(Loading, {
    color: '#0dc07f',
    width: 64,
    height: 64,
    backgroundColor: '#ffffff',
    opacity: 0.5,
    zIndex: 999,
});
Vue.component('loading', Loading);

import VueLazyload from 'vue-lazyload';
Vue.use(VueLazyload, {
    error: 'images/img_404.png',
    loading: 'images/lazyloading.gif',
});

import ToggleButton from 'vue-js-toggle-button';
Vue.use(ToggleButton);

import VueMask from 'v-mask';
Vue.use(VueMask);

import VueMeta from 'vue-meta';

Vue.config.productionTip = false;
 
Vue.use(VueMeta, {
    refreshOnceOnNavigation: true
  })

/* import VueCookieAcceptDecline from 'vue-cookie-accept-decline';
import 'vue-cookie-accept-decline/dist/vue-cookie-accept-decline.css';

Vue.component('vue-cookie-accept-decline', VueCookieAcceptDecline); */

import VeeValidate from 'vee-validate';
Vue.use(VeeValidate, {
    classes: true, // instead of `enableAutoClasses`
    fieldsBagName: 'veeFields',
    errorBagName: 'verrors',
});

const maxDimensionsRule = {
    getMessage(field, [width, height], data) {
        return (
            (data && data.message) ||
            `The ${field} field must be Minimum ${width} X ${height} pixels.`
        );
    },
    validate(files, [width, height]) {
        const validateImage = (file, width, height) => {
            const URL = window.URL || window.webkitURL;
            return new Promise((resolve) => {
                const image = new Image();
                image.onerror = () => resolve({ valid: false });
                image.onload = () =>
                    resolve({
                        valid: image.width >= Number(width) && image.height >= Number(height), // only change from official rule
                    });

                image.src = URL.createObjectURL(file);
            });
        };
        const list = [];
        for (let i = 0; i < files.length; i++) {
            // if file is not an image, reject.
            if (!/\.(jpg|svg|jpeg|png|bmp|gif)$/i.test(files[i].name)) {
                return false;
            }
            list.push(files[i]);
        }
        return Promise.all(list.map((file) => validateImage(file, width, height)));
    },
};

/*  */

Vue.prototype.$setErrorsFromResponse = function(errorResponse) {
    // only allow this function to be run if the validator exists
    if (!this.hasOwnProperty('$validator')) {
        return;
    }

    // clear errors
    this.$validator.errors.clear();

    // check if errors exist
    if (!errorResponse.hasOwnProperty('errors')) {
        return;
    }

    let errorFields = Object.keys(errorResponse.errors);

    // insert laravel errors
    errorFields.map((field) => {
        let errorString = errorResponse.errors[field].join(', ');
        this.$validator.errors.add({
            field: field,
            msg: errorString,
        });
    });
};

var baseHref = document.getElementsByTagName('base')[0].href;
window.baseHref = process.env.BASE_URL;

baseHref = baseHref.substr(-1) === '/' ? baseHref.slice(0, -1) : baseHref;

var shopId = document.querySelector('meta[name="shop_id"]').getAttribute('content');
window.shop_id = shopId;

var base_img = document.querySelector('meta[name="img-base-url"]').getAttribute('content');
window.base_img = base_img;

var appname = document.querySelector('meta[name="appname"]').getAttribute('content');
window.appname = appname;


import VueAxios from 'vue-axios';
import VueSocialauth from 'vue-social-auth';
Vue.use(VueAxios, axios);
 

Vue.config.productionTip = false;

import VueProgressBar from 'vue-progressbar';
Vue.use(VueProgressBar, {
    color: 'rgb(143, 255, 199)',
    failedColor: 'red',
    height: '3px',
});

let newVue = new Vue({});

axios.interceptors.response.use(
    (response) => {
        store.commit('setErrors', []);
        if (response.status === 200 || response.status === 201) {
            newVue.$Progress.finish();
            return Promise.resolve(response);
        } else {
            return Promise.reject(response);
        }
    },
    (error) => {
        newVue.$Progress.fail();
        if (error.response.status === 422) {
            var msg = error.response.data.message;
            if (msg == 'The given data was invalid.') {
                var msg = 'Invalid input OR some mandatory fields are blank.';
            }
            if (msg.trim()) {
                Toast.fire({
                    icon: 'warning',
                    title: msg,
                });
            }
            store.commit('setErrors', error.response.data.errors);
            return Promise.reject(error);
        } else if (error.response.status === 401) {
            store.commit('auth/setUserData', null);
            localStorage.removeItem('authToken');
            router.push({
                name: 'Login',
                query: { redirect: router.history.current.path },
            });
        } else if (
            error.response.status === 500 ||
            error.response.status === 404 ||
            error.response.status === 405
        ) {
            if (typeof error.response.data.message === 'undefined') {
                Toast.fire({
                    icon: 'error',
                    title: error.response.status === 404 ?
                        'Record not found for processing.' :
                        'Internal Server error please try again.',
                });
            } else {
                Toast.fire({
                    icon: 'error',
                    title: error.response.data.message,
                });
            }
        } else if (error.response.status === 403) {
            Toast.fire({
                icon: 'error',
                title: error.response.data.message,
            });
        } else {
            return Promise.reject(error);
        }
    },
);

axios.interceptors.request.use(function(config) {
    newVue.$Progress.start();
      //config.baseURL = 'https://wevisu.com/';
    config.headers.common = {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`,
        AuthorizationAI: `${localStorage.getItem('AIauthToken')}`,
        'Content-Type': 'application/json',
        Accept: 'application/json',
    };
    return config;
});

import { Form, HasError, AlertError } from 'vform';
window.Form = Form;

import Gate from './Gate';
Vue.prototype.$gate = new Gate(window.user);

import Swal from 'sweetalert2';

const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 10000,
    timerProgressBar: true,
    showCloseButton: true,
    backdrop: false,
    didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer);
        toast.addEventListener('mouseleave', Swal.resumeTimer); 
        toast.parentElement.classList.add('my-custom-toast-class');
      },
});
window.Swal = Swal;
window.Toast = Toast;
window.moment = moment;

Vue.component(HasError.name, HasError);
Vue.component(AlertError.name, AlertError);

//excel export
import JsonExcel from 'vue-json-excel';

Vue.component('downloadExcel', JsonExcel);

//credit card validation
import VueCardFormat from 'vue-credit-card-validation';

Vue.use(VueCardFormat);

import PerfectScrollbar from 'vue2-perfect-scrollbar';
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css';

Vue.use(PerfectScrollbar);

/**
 * Routes imports and assigning
 */
import VueRouter from 'vue-router';
Vue.use(VueRouter);
import router from './routes';

// Routes End

import VueSocialSharing from 'vue-social-sharing';
Vue.use(VueSocialSharing);

import { Datetime } from 'vue-datetime';
// You need a specific loader for CSS files
import 'vue-datetime/dist/vue-datetime.css';

Vue.use(Datetime);

Vue.component('datetime', Datetime);

import * as GmapVue from 'gmap-vue';
Vue.use(GmapVue, {
    load: {
        key: '',
        libraries: 'places', // This is required if you use the Autocomplete plugin
        // OR: libraries: 'places,drawing'
        // OR: libraries: 'places,drawing,visualization'
        // (as you require)

        //// If you want to set the version, you can do so:
        // v: '3.26',
    },

    //// If you intend to programmatically custom event listener code
    //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
    //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
    //// you might need to turn this on.
    // autobindAllEvents: false,

    //// If you want to manually install components, e.g.
    //// import {GmapMarker} from 'gmap-vue/src/components/marker'
    //// Vue.component('GmapMarker', GmapMarker)
    //// then set installComponents to 'false'.
    //// If you want to automatically install all the components this property must be set to 'true':
    installComponents: true,
});

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

import Avatar from 'vue-avatar';
Vue.component('avatar', Avatar);

import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
Vue.component("v-select", vSelect);

//Elements

Vue.component('Dropdown', require('./Elements/Dropdown.vue').default);
Vue.component('FileDropzone', require('./Elements/FileDropzone.vue').default);
Vue.component('UjPagination', require('./Elements/Pagination.vue').default);
Vue.component('OrderStatus', require('./Elements/OrderStatus.vue').default);
Vue.component('ColorBox', require('./Elements/ColorBox.vue').default);
Vue.component(
    'ProductPriceElement',
    require('./Elements/ProductPriceOption.vue').default,
);
Vue.component('QuantityBox', require('./Elements/QuantityBox.vue').default);
Vue.component('ItemSize', require('./Elements/ItemSize.vue').default);

// Components
Vue.component('pagination', require('laravel-vue-pagination'));
//Vue.component('dashboard', require('./components/Dashboard.vue'));
Vue.component('CountryList', require('./components/Country-list.vue').default);

Vue.component(
    'ProfitItemsPopup',
    require('./components/Account/common/ProfitItemsPopup.vue').default,
);

Vue.component('not-found', require('./components/NotFound.vue').default);

// Filter Section

Vue.filter('myDate', function(created) {
    return moment(created).format('MM.DD.YYYY');
});

Vue.filter('yesno', (value) =>
    value ?
    '<i class="fas fa-check green"></i>' :
    '<i class="fas fa-times red"></i>',
);

Vue.filter('toCurrency', function(value) {
    var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
    });
    value = Number(value);
    return formatter.format(value).replace(/^(\D+)/, '$1 ');
});

Vue.filter('phone', function (phone) {

    let Ccode =  phone.substring(0, phone.length - 10);
  
      let str = phone;
  let p = str.substring(2); 
  
  
      return Ccode +  p.replace(/[^0-9]/g, '')
                  .replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
  });

// end Filter

Vue.filter('handleNewLine', function(value) {
    if (value) return value.replace(/(\\r)*\\n/g, '<br>');
});

//Old
import layout from './layout/layout';

//Needed for override default layout for new design

import MainLayout from './layout/MainLayout.vue';

const app = new Vue({
    el: '#app',
    router,
    store,
    render: (h) => h(MainLayout),
    created() {
        this.$validator.extend('maxdimensions', maxDimensionsRule);
    },
});
store.dispatch('Common/fetchShop');